import React from "react";
import {QuestionDebugData} from "../../../common/webapicall";

interface Props {
	questionId: string;
	questionVariantId: string;
	debugDetails: QuestionDebugData | null;
	answer: boolean | null;
	isEnabled: boolean;
}

const QuestionDebugDetails: React.FC<Props> = ({questionId, questionVariantId, debugDetails, answer, isEnabled = false}: Props) => {
	if (!isEnabled) {
		return null;
	}

	return <div className="cih-qdbg"> ({`${debugDetails.taxonomyName} - ${questionId}/${questionVariantId} - ${debugDetails.correctAnswer ? "Yes" : "No"} - Weight: ${debugDetails.weight}`})</div>;
};

export default QuestionDebugDetails;
